export class PendingQueue {
  constructor(updateFunc) {
    this.updateFunc = updateFunc;
    this.pending = [];
    this.tempQueue = [];
    this.timer = null;
    this.flushing = false;
  }

  async flush() {
    this.flushing = true;
    this.tempQueue = [...this.pending];
    this.pending = [];

    const uList = await Promise.all(this.tempQueue.map((job) => job.job()));

    // Only update if promise resolves to a function
    const updates = uList.filter((u) => u);

    // Run collected synchronous updates
    if (updates.length > 0) {
      this.updateFunc((n) => {
        updates.forEach((update) => {
          update(n);
        });
        return n;
      });
    }

    this.tempQueue = [];
    if (this.pending.length > 0) {
      this.flush();
    } else {
      this.flushing = false;
    }
  }

  add(job, timestamp = new Date()) {
    this.pending.push({ job, timestamp });
    this.pending.sort((a, b) => a.timestamp - b.timestamp);
    if (!this.flushing) {
      if (this.timer) clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.flush();
      }, 1000);
    }
  }
}
